import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewContainerRef,
} from '@angular/core';
import { ProductImageZoomTriggerComponent } from '@spartacus/product/image-zoom/components';
import { LaunchDialogService } from '@spartacus/storefront';

@Component({
    selector: 'cx-product-image-zoom-trigger',
    templateUrl: 'product-image-zoom-trigger.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class KbProductImageZoomTriggerComponent extends ProductImageZoomTriggerComponent {

  @Input() main: any;

  constructor(
    protected override launchDialogService: LaunchDialogService,
    protected override vcr: ViewContainerRef
  ) {
    super(launchDialogService, vcr);
  }
}
